import Container from "../common/Container";
import SectionLabel from "../common/SectionLabel";
import ArrowIcon from "../common/ArrowIcon";
import { projects } from "../../data/portfolioData";
import { useRevealOnScroll } from "../../hooks/useRevealOnScroll";

const Projects = () => {
  useRevealOnScroll();

  return (
    <section id="projects" className="projects-section">
      <Container>
        <SectionLabel number="02" label="Selected Work" />

        <div className="projects-grid">
          {projects.map((project) => (
            <a
              href={project.href}
              className={`project-card reveal-on-scroll ${
                project.featured ? "featured" : ""
              }`}
              key={project.number}
              target={project.external ? "_blank" : undefined}
              rel={project.external ? "noopener noreferrer" : undefined}
            >
              <div className="project-accent" />

              <div className="project-card-inner">
                <div className="project-num">— {project.number}</div>

                <div className="project-title">{project.title}</div>

                <p className="project-desc">{project.description}</p>

                <div className="project-tech">
                  {project.tech.map((tech) => (
                    <span className="tech-tag" key={tech}>
                      {tech}
                    </span>
                  ))}
                </div>

                <div className="project-link">
                  Learn more
                  <ArrowIcon />
                </div>
              </div>
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Projects;
